import { render, staticRenderFns } from "./SchoolManagerInstructions.vue?vue&type=template&id=15a848c7&scoped=true"
import script from "./SchoolManagerInstructions.vue?vue&type=script&lang=js"
export * from "./SchoolManagerInstructions.vue?vue&type=script&lang=js"
import style0 from "./SchoolManagerInstructions.vue?vue&type=style&index=0&id=15a848c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a848c7",
  null
  
)

export default component.exports